module.exports = __webpack_public_path__ + "img/loyalty.6bab4761.svg";